import React, { useState, useEffect, useRef } from 'react';
import './TypewriterTrail.css';

const TypewriterTrail = ({
  text = '',
  speed = 5, // milliseconds per character
  onComplete = () => {},
  className = ''
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    // Reset everything when text changes
    setDisplayedText('');
    setCurrentIndex(0);
    setIsComplete(false);
    
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, [text]);

  useEffect(() => {
    if (currentIndex < text.length && text.length > 0) {
      timeoutRef.current = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);
    } else if (currentIndex >= text.length && text.length > 0 && !isComplete) {
      setIsComplete(true);
      onComplete();
    }

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [currentIndex, text, speed, onComplete, isComplete]);

  // Pause typewriter effect when user is selecting text
  useEffect(() => {
    const handleSelectionStart = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };

    const handleSelectionEnd = () => {
      if (currentIndex < text.length && text.length > 0 && !isComplete) {
        timeoutRef.current = setTimeout(() => {
          setDisplayedText(prev => prev + text[currentIndex]);
          setCurrentIndex(prev => prev + 1);
        }, speed);
      }
    };

    document.addEventListener('selectstart', handleSelectionStart);
    document.addEventListener('selectionchange', handleSelectionEnd);

    return () => {
      document.removeEventListener('selectstart', handleSelectionStart);
      document.removeEventListener('selectionchange', handleSelectionEnd);
    };
  }, [currentIndex, text, speed, isComplete]);

  return (
    <div className={`typewriter-container ${className}`}>
      <div className="typewriter-text">
        {displayedText}
        {!isComplete && (
          <span className="typewriter-cursor">|</span>
        )}
      </div>
    </div>
  );
};

export default TypewriterTrail;